import { render, staticRenderFns } from "./country.vue?vue&type=template&id=50cb40c4"
import script from "./country.vue?vue&type=script&lang=js"
export * from "./country.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports